import { createSlice } from "@reduxjs/toolkit";

export const globalSlice = createSlice({
  name: "global",
  initialState: {
    isCompactMode: false,
    mapType: 2,
    map2Type: 2,
    map: { is3D: false, is2D: false },
    splitView: false,
    Layer3DSearchResult: {},
    Layer3DSearchZoomTo1st: false,
    graphicSearchInput: {},
    textualSearchInput: {},
  },
  reducers: {
    enableCompactMode(state) {
      state.isCompactMode = true;
    },
    toggleMapType(state) {
      state.mapType = state.mapType == 3 ? 2 : 3;
      state.map2Type = state.mapType;
    },
    changeMapType(state, action) {
      state.mapType = action.payload;
      state.map2Type = action.payload;
    },
    toggleSplitMapType(state) {
      state.map2Type = state.map2Type == 3 ? 2 : 3;
    },
    updateGlobalInputData(state, action) {
      console.log("updateGlobalInputData state", state, "action", action);
      delete state.inputData.noZoom;
      state.inputData = { ...state.inputData, ...action.payload };
    },
    setManageBmRightChecked(state) {
      state.didManageBmRightChecked = true;
    },
    setUserCanManageBm(state) {
      state.canManageGlobal = true;
    },
    setSplitViewMode(state) {
      // check spliview mode whether is enabled
      state.splitView = true;
    },
    setSplitViewModeClose(state) {
      // check spliview mode whether is disenabled
      state.splitView = false;
    },
    updateSearchResults(state, action) {
      state.Layer3DSearchResult = action.payload;
      console.log("Layer3DSearchResult state", state, "action", action);
    },
    setLayer3DSearchZoomTo1st(state, action) {
      state.Layer3DSearchZoomTo1st = action.payload;
    },
    saveGraphicSearchInput(state, action) {
      state.graphicSearchInput = action.payload;
    },
    saveTextualSearchInput(state, action) {
      state.textualSearchInput = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  enableCompactMode,
  toggleMapType,
  toggleSplitMapType,
  changeMapType,
  updateGlobalInputData,
  updateManage3DLayerComponent,
  setManageBmRightChecked,
  setUserCanManageBm,
  setSplitViewMode,
  setSplitViewModeClose,
  updateSearchResults,
  setLayer3DSearchZoomTo1st,
  saveGraphicSearchInput,
  saveTextualSearchInput,
} = globalSlice.actions;

export default globalSlice.reducer;
